// extracted by mini-css-extract-plugin
export default {"InheritLibraryDialog":"InheritLibraryDialog_InheritLibraryDialog__23UUL"};